import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import imgUrl from "../assets/images/imgUrl";

// MUI Icons
import PublicIcon from "@mui/icons-material/Public";
import FlagIcon from "@mui/icons-material/Flag";
import PersonIcon from "@mui/icons-material/Person";
import PaymentsIcon from "@mui/icons-material/Payments";
import SchoolIcon from "@mui/icons-material/School";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import HandshakeIcon from "@mui/icons-material/Handshake";
import GroupsIcon from "@mui/icons-material/Groups";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import GavelIcon from "@mui/icons-material/Gavel";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import MovieIcon from "@mui/icons-material/Movie";

// Your Custom Font Variables
const FONT_NELCO = "Nelco Regular";
const FONT_DIN_REGULAR = "DIN Pro Regular";
const FONT_DIN_MEDIUM = "DIN Pro Medium";
const FONT_DIN_BOLD = "DIN Pro Bold";
const FONT_PHILOSOPHER = "Philosopher";

const globalAllocations = [
  { title: "IAP 12 International Programme Director",subtitle:"of programme", percent: "2.1%", icon: <PublicIcon />, color: "#197fe6" },
  { title: "IAP International Peace Country Director",subtitle:"of country", percent: "2.1%", icon: <FlagIcon />, color: "#6366f1" },
  { title: "IAP 12 Programme Country Director", subtitle:"of programme in country",percent: "7%", icon: <PersonIcon />, color: "#10b981" },
  { title: "Payment Gateway / Bank Charges",percent: "5.5%", icon: <PaymentsIcon />, color: "#f59e0b" },
];

const revenueStreams = [
  { title: "Schools,Colleges,Universities", percent: "7%", sub: "21% Education Institution", icon: <SchoolIcon />, color: "#3b82f6" },
  { title: "Organisations / Corporates", percent: "7%", sub: "21% Organisation", icon: <CorporateFareIcon />, color: "#6366f1" },
  { title: "Event Sponsors / Contributions", sub: "21% Sponsorship Contribution", icon: <HandshakeIcon />, color: "#10b981" },
  { title: "Contribution received on Events",sub: "21% of Contribution", icon: <GroupsIcon />, color: "#f59e0b" },
  { title: "IAP Registration ($21)", sub: "21% Registration Allocation", icon: <ShoppingBagIcon />, color: "#f43f5e" },
  { title: "Gifts", percent: "7%",  icon: <MenuBookIcon />, color: "#06b6d4" },
{
  title: "Institute",
  dual: true, 
  a: {
    label: "Online Courses",
    percent: "7%",
    sub: "40% Course Facilitator"
  },
  b: {
    label: "Offline Courses",
    percent: "7%",
    sub: "60% Course Facilitator"
  },
  icon: <PersonAddIcon />,
  color: "#8b5cf6"
},  { title: "Influence", percent: "4%", sub: "21% Influencers and 19% Organisation", icon: <VolunteerActivismIcon />, color: "#14b8a6" },
{
  title: "Cafee",
  dual: true,
  a: {
    label: "Cafee Franchise Fee",
    percent: "21%",
    sub: "79% I Am Peacekeeper Movement"
  },
  b: {
    label: "Gross Operating Profit",
    percent: "1.2%",
    sub: "7.2% I Am Peacekeeper Movement"
  },
  icon: <GavelIcon />,
  color: "#f97316"
},  { title: "Voice", sub: "21% Voices Programme Allocation", icon: <TravelExploreIcon />, color: "#d946ef" },
  { title: "Arts", percent: "21%", sub: "51% Artist / Contributor", icon: <FavoriteIcon />, color: "#ec4899" },
  { title: "Publications", percent: "21%", sub: "40% Author", icon: <MovieIcon />, color: "#197fe6" },
];

const Rewards = () => {
  return (
    <Box sx={{ bgcolor: "#fdfdfd", pb: 15 }}>
      {/* 1. BANNER IMAGE SECTION */}
      <Box
        className="rewardsBg commonBannerBg"
        sx={{
          width: "100%",
          height: { xs: "250px", md: "400px" },
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      />

      {/* 2. TEXT SECTION (Appears AFTER the banner) */}
      <Container maxWidth="lg" sx={{ mt: 6, mb: 8, textAlign: "center" }}>
        <Typography
          variant="h1"
          sx={{
            fontFamily: FONT_NELCO,
            fontSize: { xs: "2.5rem", md: "4rem" },
            color: "#2c738d",
            lineHeight: 1.1,
            mb: 2,
          }}
        >
Income through Values
        </Typography>
        <img src={imgUrl.peaceIcon} alt="Peace Icon" style={{ width: "100px", height: "100px", margin: "20px auto" }} />
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            fontFamily: FONT_DIN_REGULAR,
            fontSize: { xs: "1rem", md: "1.6rem" },
            color: "#555",
            fontWeight: "normal",
          }}
        >
Serving others while supporting yourself.
        </Typography>
      </Container>

      {/* 3. MAIN CONTENT CARDS */}
      <Container maxWidth="lg" alignItems="center">
        
        {/* SECTION: FOR ALL PROGRAMMES (4 Cards - Strictly ONE LINE) */}
        <Box sx={{ mb: 12 }}>
          <Box sx={{textAlign: "center", py: 1.5, mb: 4, borderRadius: 1 }}>
            <Typography variant="h1">
              FOR ALL PROGRAMMES
            </Typography>
          </Box>
          
          <Grid 
            container 
            spacing={1} 
            justifyContent="center" 
          >
            {globalAllocations.map((item, index) => (
<Grid
  item
  xs={12}   // 1 card per row on mobile
  sm={6}    // 2 per row on small screens
  md={3}    // 4 per row on desktop
  key={index}
  sx={{ display: "flex", justifyContent: "center" }}
>                 <Card 
                  sx={{ 
                    textAlign: "center",
                    borderBottom: `6px solid ${item.color}`, 
                    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                    borderRadius: 3,
                    height: "100%",
                    width:"270px", 
                    display: "flex", 
                    flexDirection: "column",
                  }}
                >
                  <CardContent sx={{ py: 4 }}>
                    <Box sx={{ color: item.color, mb: 2 }}>
                      {React.cloneElement(item.icon, { sx: { fontSize: 50 } })}
                    </Box>
                    <Typography sx={{ fontFamily: FONT_DIN_MEDIUM, fontSize: "0.85rem", mt: 2, color: "#555", px: 1 }}>
                      {item.title}
                    </Typography>
                    <Typography sx={{ fontFamily: FONT_DIN_BOLD, fontWeight: 700, fontSize: "2.2rem", color: "#2c3e50", lineHeight: 1 }}>
                      {item.percent}
                    </Typography>
                    <Typography sx={{ fontFamily: FONT_DIN_MEDIUM, fontSize: "0.85rem", mt: 2, color: "#555", px: 1 }}>
                      {item.subtitle}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

{/* SECTION: I AM PEACEKEEPER INCENTIVES (12 Card Grid) */}
<Box sx={{ mt: 10 }}>
  <Box sx={{ textAlign: "center", py: 1.5, mb: 1 }}>
    <Typography variant="h1" sx={{fontSize:"25px !important"}}>
      I AM PEACEKEEPER – EARN WHILE YOU SERVE INCENTIVES
    </Typography>
  </Box>
  
  <Typography 
    sx={{ 
      fontFamily: FONT_PHILOSOPHER, 
      textAlign: "center", 
      color: "#3a7a91", 
      fontSize: "1.3rem", 
      fontWeight: 700, 
      mb: 5, 
      mt: 2 
    }}
  >
    Revenue Streams & Referral Allocations
  </Typography>

  {/* Grid Container */}
  <Grid container spacing={2} alignItems="stretch" justifyContent="center"> 
    {revenueStreams.map((item, index) => (
      <Grid 
        item 
        xs={12}    // 1 card on mobile
        sm={6}     // 2 cards on small tablets
        md={3}     // 4 cards per row on desktop (12 / 3 = 4)
        key={index} 
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} // Forces the Grid item to expand the Card
      >
        <Card 
          sx={{ 
            display: "flex", 
            flexDirection: "column", 
            width: "300px",
            height: "300px",
            textAlign: "center", 
            borderBottom: `4px solid ${item.color}`, 
            borderRadius: 3,
            transition: "transform 0.3s ease",
            "&:hover": { transform: "translateY(-8px)", boxShadow: 8 }
          }}
        >
          <CardContent sx={{ py: 4 }}>
  <Box sx={{ color: item.color, mb: 2 }}>
    {React.cloneElement(item.icon, { sx: { fontSize: 50 } })}
  </Box>

  {/* Title */}
  <Typography
    sx={{
      fontFamily: FONT_DIN_MEDIUM,
      fontSize: "0.9rem",
      color: "#555",
      mb: 2
    }}
  >
    {item.title}
  </Typography>

  {/* Dual Section Layout */}
  {item.dual ? (
    <Box sx={{ display: "flex", alignItems: "stretch", mt: 1 }}>
  
  {/* Section A */}
  <Box
    sx={{
      flex: 1,
      pr: 2,
      borderRight: "2px dotted #ccc",   // 👈 Dotted Divider
    }}
  >
    <Typography sx={{ fontSize: "0.75rem", fontFamily: FONT_DIN_MEDIUM }}>
     {item.a.label}
    </Typography>

    <Typography
      sx={{
        fontFamily: FONT_DIN_BOLD,
        fontSize: "1.8rem",
        fontWeight: 700,
        color: "#2c3e50"
      }}
    >
      {item.a.percent}
    </Typography>

    <Typography sx={{ fontSize: "0.8rem", fontFamily: FONT_DIN_MEDIUM }}>
      {item.a.sub}
    </Typography>
  </Box>

  {/* Section B */}
  <Box sx={{ flex: 1, pl: 2 }}>
    <Typography sx={{ fontSize: "0.75rem", fontFamily: FONT_DIN_MEDIUM }}>
     {item.b.label}
    </Typography>

    <Typography
      sx={{
        fontFamily: FONT_DIN_BOLD,
        fontSize: "1.8rem",
        fontWeight: 700,
        color: "#2c3e50"
      }}
    >
      {item.b.percent}
    </Typography>

    <Typography sx={{ fontSize: "0.8rem", fontFamily: FONT_DIN_MEDIUM }}>
      {item.b.sub}
    </Typography>
  </Box>

</Box>
  ) : (
    <>
      {/* Normal Card Layout */}
      <Typography
        sx={{
          fontFamily: FONT_DIN_BOLD,
          fontWeight: 700,
          fontSize: "2.2rem",
          color: "#2c3e50",
          lineHeight: 1
        }}
      >
        {item.percent}
      </Typography>

      <Typography
        sx={{
          fontFamily: FONT_DIN_MEDIUM,
          fontSize: "0.85rem",
          mt: 2,
          color: "#555",
          px: 1
        }}
      >
        {item.sub}
      </Typography>
    </>
  )}
</CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
</Box>
        {/* Disclaimer Text */}
        <Box sx={{ mt: 8, textAlign: "center" }}>
          <Typography sx={{ fontFamily: FONT_PHILOSOPHER, color: "#3a7a91", fontSize: "0.95rem", fontStyle: "italic" }}>
            * If there is a positive operating profit (EBITDA — Earnings Before Interest, Taxes, Depreciation and Amortization)
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Rewards;